    (function () {
      if (window.metaboxConfiguratorEnvironments) return;

      function normalizeEnvironmentItem(item) {
        if (!item || typeof item !== 'object') return null;

        const nestedEnvironment = item.environment && typeof item.environment === 'object' ? item.environment : null;
        const id = item.environmentId || item.id || (nestedEnvironment && nestedEnvironment.id) || null;
        if (!id) return null;

        return {
          id,
          label: item.label || (nestedEnvironment && nestedEnvironment.title) || item.title || 'Environment',
          slots: Array.isArray(item.slots)
            ? item.slots
            : Array.isArray(nestedEnvironment && nestedEnvironment.slots)
              ? nestedEnvironment.slots
              : [],
        };
      }

      function getEnvironmentThumbnailUrl(thumbnailList) {
        if (!Array.isArray(thumbnailList) || thumbnailList.length === 0) return '';

        const withValidUrl = thumbnailList.filter((thumbnail) => thumbnail && thumbnail.urlPath);
        if (!withValidUrl.length) return '';

        const sortedBySize = withValidUrl
          .slice()
          .sort((left, right) => (left.width || 0) - (right.width || 0));

        return (sortedBySize.find((thumbnail) => (thumbnail.width || 0) >= 100) || sortedBySize[0]).urlPath || '';
      }

      function getEnvironmentSelectionsStore() {
        window.metaboxConfigurator = window.metaboxConfigurator || {};
        if (
          !window.metaboxConfigurator.environmentSelections ||
          typeof window.metaboxConfigurator.environmentSelections !== 'object'
        ) {
          window.metaboxConfigurator.environmentSelections = {};
        }

        return window.metaboxConfigurator.environmentSelections;
      }

      function getStoredDecorPreference() {
        window.metaboxConfigurator = window.metaboxConfigurator || {};
        const value = window.metaboxConfigurator.decorPreference;
        return value === 'decor' || value === 'nodecor' ? value : null;
      }

      function setStoredDecorPreference(value) {
        if (value !== 'decor' && value !== 'nodecor') return;
        window.metaboxConfigurator = window.metaboxConfigurator || {};
        window.metaboxConfigurator.decorPreference = value;
      }

      function normalizeText(value) {
        if (!value) return '';
        return value
          .toString()
          .trim()
          .toLowerCase()
          .replace(/[_/]+/g, ' ')
          .replace(/[^a-z0-9\s]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function getComponentDisplayName(component) {
        if (!component || typeof component !== 'object') return '';
        return (
          component.name ||
          (component.product && component.product.title) ||
          (component.componentType && component.componentType.name) ||
          ''
        );
      }

      function getDecorVariant(component) {
        const normalizedName = normalizeText(getComponentDisplayName(component));
        if (!normalizedName) return null;
        if (normalizedName.includes('nodecor') || normalizedName.includes('no decor')) return 'nodecor';
        if (normalizedName.includes('decor')) return 'decor';
        return null;
      }

      function getDecorPairingKey(component) {
        const normalizedName = normalizeText(getComponentDisplayName(component));
        if (!normalizedName) return '';

        return normalizedName
          .replace(/\bnodecor\b/g, ' ')
          .replace(/\bno decor\b/g, ' ')
          .replace(/\bdecor\b/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function getActiveComponentIds() {
        const envelope = window.__lastMetaboxEnvelope;
        const configurationTree = Array.isArray(envelope && envelope.configurationTree) ? envelope.configurationTree : [];
        return new Set(configurationTree.map((node) => node && node.id).filter(Boolean));
      }

      function getConfiguratorComponents() {
        const envelope = window.__lastMetaboxEnvelope;
        const configurator = envelope && envelope.configurator;
        const components = configurator && configurator.components;
        return Array.isArray(components) ? components : [];
      }

      function getDecorSwitchGroups() {
        const components = getConfiguratorComponents();
        if (!components.length) return [];

        const activeIds = getActiveComponentIds();
        if (!activeIds.size) return [];

        const groupsByTypeId = new Map();

        components.forEach((component) => {
          const typeId = component && component.componentType && component.componentType.id;
          if (!typeId || !activeIds.has(component.id)) return;

          const activeVariant = getDecorVariant(component);
          if (!activeVariant) return;
          const targetVariant = activeVariant === 'nodecor' ? 'decor' : 'nodecor';
          const activePairingKey = getDecorPairingKey(component);

          const typeComponents = components.filter(
            (candidate) => candidate && candidate.componentType && candidate.componentType.id === typeId
          );

          const exactTargetMatch =
            typeComponents.find((candidate) => {
              if (getDecorVariant(candidate) !== targetVariant) return false;
              return getDecorPairingKey(candidate) === activePairingKey;
            }) || null;

          const fallbackTargetMatch =
            typeComponents.find((candidate) => getDecorVariant(candidate) === targetVariant) || null;

          const decorComponent =
            activeVariant === 'decor'
              ? component
              : exactTargetMatch || fallbackTargetMatch;

          const nodecorComponent =
            activeVariant === 'nodecor'
              ? component
              : exactTargetMatch || fallbackTargetMatch;

          if (!decorComponent || !nodecorComponent) return;

          groupsByTypeId.set(typeId, {
            typeId,
            activeId: component.id,
            activeVariant,
            decorComponent,
            nodecorComponent,
          });
        });

        return Array.from(groupsByTypeId.values());
      }

      function getCurrentDecorMode(groups) {
        if (!Array.isArray(groups) || !groups.length) return null;
        return groups.some((group) => group.activeVariant === 'nodecor') ? 'nodecor' : 'decor';
      }

      function waitForConfiguratorRefresh(timeoutMs) {
        const ms = Number(timeoutMs) > 0 ? Number(timeoutMs) : 1200;
        return new Promise((resolve) => {
          let settled = false;

          function done(result) {
            if (settled) return;
            settled = true;
            window.removeEventListener('metabox:slotsReady', handleSlotsReady);
            clearTimeout(timeoutId);
            resolve(result);
          }

          function handleSlotsReady() {
            done(true);
          }

          const timeoutId = setTimeout(() => done(false), ms);
          window.addEventListener('metabox:slotsReady', handleSlotsReady, { once: true });
        });
      }

      async function switchDecorMode(targetMode, options = {}) {
        const persistPreference = options.persistPreference !== false;
        if (persistPreference) {
          setStoredDecorPreference(targetMode);
        }

        const groups = getDecorSwitchGroups();
        if (!groups.length) return;

        const selectComponent =
          window.metaboxConfigurator && typeof window.metaboxConfigurator.selectComponent === 'function'
            ? window.metaboxConfigurator.selectComponent
            : null;
        if (!selectComponent) return;

        for (const group of groups) {
          const targetComponent = targetMode === 'nodecor' ? group.nodecorComponent : group.decorComponent;
          if (!targetComponent || targetComponent.id === group.activeId) continue;

          const componentTypeId = targetComponent?.componentType?.id || null;
          const isRoot = Boolean(targetComponent?.componentType?.isRoot);
          const changed = selectComponent(targetComponent.id, componentTypeId, isRoot);
          if (!changed) continue;
          await waitForConfiguratorRefresh(900);
        }

        if (window.metaboxMwAdapter && typeof window.metaboxMwAdapter.reapplyCheckedSelections === 'function') {
          await window.metaboxMwAdapter.reapplyCheckedSelections();
        }
      }

      async function restoreStoredDecorPreference() {
        const preferredMode = getStoredDecorPreference();
        if (preferredMode !== 'decor' && preferredMode !== 'nodecor') return 'none';

        const groups = getDecorSwitchGroups();
        const currentMode = getCurrentDecorMode(groups);
        if (!currentMode || currentMode === preferredMode) return 'none';

        if (window.metaboxConfigurator.__decorPreferenceRestoreInFlight === preferredMode) {
          return 'pending';
        }

        window.metaboxConfigurator.__decorPreferenceRestoreInFlight = preferredMode;

        try {
          await switchDecorMode(preferredMode, { persistPreference: false });
          return 'restored';
        } finally {
          if (window.metaboxConfigurator.__decorPreferenceRestoreInFlight === preferredMode) {
            window.metaboxConfigurator.__decorPreferenceRestoreInFlight = null;
          }
        }
      }

      function renderDecorToggle(ctx) {
        const decorToggle = ctx && ctx.decorToggle;
        if (!decorToggle) return;

        decorToggle.innerHTML = '';

        const groups = getDecorSwitchGroups();
        const canSelectComponent = Boolean(
          window.metaboxConfigurator && typeof window.metaboxConfigurator.selectComponent === 'function'
        );
        if (!groups.length || !canSelectComponent) {
          decorToggle.hidden = true;
          return;
        }

        const detectedMode = getCurrentDecorMode(groups) || 'decor';
        const storedMode = getStoredDecorPreference();
        const currentMode = storedMode || detectedMode;
        if (!storedMode) {
          setStoredDecorPreference(detectedMode);
        }
        decorToggle.hidden = false;

        const title = document.createElement('h4');
        title.className = 'mw-apo-environment-slot-title';
        title.textContent = 'Decor';
        decorToggle.appendChild(title);

        const toggleList = document.createElement('div');
        toggleList.className = 'mw-apo-environment-list mw-apo-environment-list--decor';

        const decorButton = document.createElement('button');
        decorButton.type = 'button';
        decorButton.className = 'mw-apo-environment-button';
        decorButton.textContent = 'Decor';
        decorButton.classList.toggle('is-active', currentMode === 'decor');
        decorButton.setAttribute('aria-pressed', currentMode === 'decor' ? 'true' : 'false');
        decorButton.addEventListener('click', async (event) => {
          if (!event.isTrusted) return;
          await switchDecorMode('decor');
          render(ctx);
        });

        const nodecorButton = document.createElement('button');
        nodecorButton.type = 'button';
        nodecorButton.className = 'mw-apo-environment-button';
        nodecorButton.textContent = 'No decor';
        nodecorButton.classList.toggle('is-active', currentMode === 'nodecor');
        nodecorButton.setAttribute('aria-pressed', currentMode === 'nodecor' ? 'true' : 'false');
        nodecorButton.addEventListener('click', async (event) => {
          if (!event.isTrusted) return;
          await switchDecorMode('nodecor');
          render(ctx);
        });

        toggleList.appendChild(decorButton);
        toggleList.appendChild(nodecorButton);
        decorToggle.appendChild(toggleList);
      }

      function resolveContext(ctx) {
        const environmentOptionsPanel = ctx && ctx.environmentOptionsPanel;
        if (!environmentOptionsPanel) return false;

        let environmentOptionsRoot = environmentOptionsPanel.querySelector('[data-configure-environment-options]');
        if (!environmentOptionsRoot) {
          const liquidEnvironmentMountId = ctx?.productInfo?.dataset?.configureEnvironmentMountId;
          const liquidEnvironmentRoot = liquidEnvironmentMountId ? document.getElementById(liquidEnvironmentMountId) : null;

          if (liquidEnvironmentRoot) {
            environmentOptionsRoot = liquidEnvironmentRoot;
            environmentOptionsPanel.appendChild(environmentOptionsRoot);
          }
        }

        if (!environmentOptionsRoot) return false;

        const environmentList = environmentOptionsRoot.querySelector('[data-configure-environment-list]');
        const decorToggle = environmentOptionsRoot.querySelector('[data-configure-decor-toggle]');
        const environmentSlots = environmentOptionsRoot.querySelector('[data-configure-environment-slots]');
        if (!environmentList || !environmentSlots || !decorToggle) return false;

        ctx.environmentOptionsRoot = environmentOptionsRoot;
        ctx.environmentList = environmentList;
        ctx.decorToggle = decorToggle;
        ctx.environmentSlots = environmentSlots;
        return true;
      }

      function render(ctx) {
        if (!resolveContext(ctx)) return;

        const { environmentList, environmentSlots } = ctx || {};
        if (!environmentList || !environmentSlots) return;

        const rawEnvironments = Array.isArray(window.metaboxConfigurator && window.metaboxConfigurator.environments)
          ? window.metaboxConfigurator.environments
          : [];
        const environments = rawEnvironments.map(normalizeEnvironmentItem).filter(Boolean);
        const selectionsStore = getEnvironmentSelectionsStore();

        environmentList.innerHTML = '';
        environmentSlots.innerHTML = '';

        if (!environments.length) {
          const emptyState = document.createElement('div');
          emptyState.className = 'mw-apo-environment-empty';
          emptyState.textContent = 'Environment options are not available yet.';
          environmentSlots.appendChild(emptyState);
          return;
        }

        const currentActiveId = window.metaboxConfigurator && window.metaboxConfigurator.activeEnvironmentId;
        const activeEnvironment = environments.find((environment) => environment.id === currentActiveId) || environments[0];
        if (activeEnvironment && window.metaboxConfigurator) {
          window.metaboxConfigurator.activeEnvironmentId = activeEnvironment.id;
        }

        if (!selectionsStore[activeEnvironment.id]) {
          selectionsStore[activeEnvironment.id] = {};
        }

        environments.forEach((environment) => {
          const environmentButton = document.createElement('button');
          environmentButton.type = 'button';
          environmentButton.className = 'mw-apo-environment-button';
          environmentButton.textContent = environment.label;
          environmentButton.classList.toggle('is-active', environment.id === activeEnvironment.id);
          environmentButton.setAttribute('aria-pressed', environment.id === activeEnvironment.id ? 'true' : 'false');

          environmentButton.addEventListener('click', () => {
            if (window.metaboxConfigurator && typeof window.metaboxConfigurator.changeEnvironment === 'function') {
              const changed = window.metaboxConfigurator.changeEnvironment(environment.id);
              if (!changed) return;
            } else if (window.metaboxConfigurator) {
              window.metaboxConfigurator.activeEnvironmentId = environment.id;
            }

            render(ctx);
          });

          environmentList.appendChild(environmentButton);
        });

        renderDecorToggle(ctx);

        if (!activeEnvironment.slots.length) {
          const emptySlotsState = document.createElement('div');
          emptySlotsState.className = 'mw-apo-environment-empty';
          emptySlotsState.textContent = 'No material slots for this environment.';
          environmentSlots.appendChild(emptySlotsState);
          return;
        }

        activeEnvironment.slots.forEach((slot) => {
          const slotMaterials = Array.isArray(slot.enabledMaterials) ? slot.enabledMaterials : [];
          if (!slotMaterials.length) return;

          const slotId = slot.id;
          const existingSelection = selectionsStore[activeEnvironment.id][slotId];
          const selectedMaterialId = slotMaterials.some((material) => material && material.id === existingSelection)
            ? existingSelection
            : slotMaterials[0].id;
          selectionsStore[activeEnvironment.id][slotId] = selectedMaterialId;

          const slotSection = document.createElement('section');
          slotSection.className = 'mw-apo-environment-slot';

          const slotTitle = document.createElement('h4');
          slotTitle.className = 'mw-apo-environment-slot-title';
          slotTitle.textContent = slot.label || 'Material';
          slotSection.appendChild(slotTitle);

          const materialGrid = document.createElement('div');
          materialGrid.className = 'mw-apo-environment-material-grid';

          slotMaterials.forEach((material) => {
            if (!material || !material.id) return;

            const materialButton = document.createElement('button');
            materialButton.type = 'button';
            materialButton.className = 'mw-apo-environment-material';
            materialButton.classList.toggle('is-active', material.id === selectedMaterialId);
            materialButton.setAttribute('aria-pressed', material.id === selectedMaterialId ? 'true' : 'false');
            materialButton.title = material.title || 'Material';

            const swatchMedia = document.createElement('span');
            swatchMedia.className = 'mw-apo-environment-swatch';
            const thumbnailUrl = getEnvironmentThumbnailUrl(material.thumbnailList);

            if (thumbnailUrl) {
              const swatchImage = document.createElement('img');
              swatchImage.src = thumbnailUrl;
              swatchImage.alt = material.title || 'Material';
              swatchImage.loading = 'lazy';
              swatchMedia.appendChild(swatchImage);
            } else {
              swatchMedia.classList.add('mw-apo-environment-swatch--placeholder');
            }

            const materialTitle = document.createElement('span');
            materialTitle.className = 'mw-apo-environment-material-title';
            materialTitle.textContent = material.title || 'Material';

            materialButton.appendChild(swatchMedia);
            materialButton.appendChild(materialTitle);

            materialButton.addEventListener('click', () => {
              if (
                window.metaboxConfigurator &&
                typeof window.metaboxConfigurator.changeEnvironmentMaterial === 'function'
              ) {
                const changed = window.metaboxConfigurator.changeEnvironmentMaterial(slotId, material.id);
                if (!changed) return;
              }

              selectionsStore[activeEnvironment.id][slotId] = material.id;
              render(ctx);
            });

            materialGrid.appendChild(materialButton);
          });

          slotSection.appendChild(materialGrid);
          environmentSlots.appendChild(slotSection);
        });
      }

      function bind(ctx) {
        const optionsFrame = ctx && ctx.optionsFrame;
        if (!optionsFrame || optionsFrame.dataset.configureEnvironmentEventsBound === 'true') return;

        const rerenderEnvironmentOptions = async function () {
          const restoreState = await restoreStoredDecorPreference();
          if (restoreState === 'pending') return;
          render(ctx);
        };

        window.addEventListener('metabox:ready', rerenderEnvironmentOptions);
        window.addEventListener('metabox:environmentsReady', rerenderEnvironmentOptions);
        optionsFrame.dataset.configureEnvironmentEventsBound = 'true';
      }

      function setup(ctx) {
        if (!resolveContext(ctx)) return false;
        render(ctx);
        bind(ctx);
        return true;
      }

      window.metaboxConfiguratorEnvironments = {
        resolveContext,
        render,
        bind,
        setup,
      };
    })();
